export enum UserStatus {
  NotRegister = 0,
  Registered = 1,
  Verified = 2,
  Cancelled = 3,
}